export const FormType = {
  1481: 'master_listing_table',
  1482: 'simple_form',
  1483: 'horizontal_tab_navigation',
  1484: 'vertical_tab_navigation',
  1540: 'form_builder_dashboard'
} as const;

export const OtherActionType = [
  {
    name: 'Approve',
    code: 'APPROVE'
  },
  {
    name: 'Reject',
    code: 'REJECT'
  },
  {
    name: 'Save',
    code: 'SAVE'
  }
] as const;

export const FormTypeCodeToName = {
  'master_listing_table': 'Master Listing Table',
  'simple_form': 'Simple Form',
  'horizontal_tab_nav': 'Horizontal Tab Navigation',
  'vertical_tab_nav': 'Vertical Tab Navigation',
  'fbdashboard': 'Form Builder Dashboard'
} as const;
